import { LINK_PAGE_THEME_PRESETS } from "../Dashboard/linkPageBuilderConfig";
import { bookingDemoServices } from "../Booking/BookMePreview";
import cover480 from "../../images/public-site/creator-abstract-cover-480.webp?url";
import cover800 from "../../images/public-site/creator-abstract-cover-800.webp?url";

export const demoCreator = {
  name: "John", surname: "Doe", nickname: "johndoe", aboutMe: "Creator and host.",
  bookingProfile: { payoutsReady: true, services: bookingDemoServices },
};

export const demoCreatorName = `${demoCreator.name} ${demoCreator.surname}`;

export const creatorPageThemes = ["tiffany", "blue-hour", "bonjourno"].map(key =>
  LINK_PAGE_THEME_PRESETS.find(preset => preset.key === key));

export const closingPageThemes = ["forest-muse", "ultraviolet", "saffron"].map(key =>
  LINK_PAGE_THEME_PRESETS.find(preset => preset.key === key));

export const creatorCover = {
  src: "/images/creator-abstract-cover.webp", width: 1200, height: 675,
  srcSet: `${cover480} 480w, ${cover800} 800w, /images/creator-abstract-cover.webp 1200w`,
  alt: "A warm stone sculpture with a flowing, twisted loop.",
};

export const getDemoLinkVersion = (theme) => ({
  theme,
  layout: { alignment: "center", width: "standard", spacing: "normal" },
  items: [
    { id: "website", type: "link", title: "My website", url: "https://example.com", isVisible: true, sortOrder: 0 },
    { id: "articles", type: "link", title: "Read my articles", url: "https://example.com/articles", isVisible: true, sortOrder: 1 },
  ],
});

export const creatorTools = [
  { key: "links", title: "Build your link page", shortTitle: "Link page", description: "Your links and work, on a page you can edit and share.", action: "Create your link page" },
  { key: "bookings", title: "Offer paid services", shortTitle: "Book Me", description: "List your services and prices. You decide which requests to accept.", action: "Set up Book Me" },
  { key: "paidSubscriptions", title: "Write for paying subscribers", shortTitle: "Paid articles", description: "Publish paid articles for readers who subscribe to you.", action: "Set up paid articles" },
  { key: "publish", title: "Plan your social posts", shortTitle: "Social posts", description: "Prepare and schedule posts to supported social accounts.", action: "Plan a social post" },
];

export const homeTestimonials = [
  {
    name: "Jennifer C.",
    excerpt: "I only pay when I get booked.",
    quote: "I used BonJourno to jumpstart my consulting business. Their free link-in-bio tool funnels clients right to the booking tool, and I only pay when I get booked. There’s no monthly fee on months I don’t earn a new client, so there’s no risk in signing up.",
  },
  {
    name: "Julia S.",
    excerpt: "It’s easy to use, looks lovely, and everything feels intuitive.",
    quote: "I use BonJourno for my personal link-in-bio page. It’s easy to use, looks lovely, and everything feels intuitive.",
  },
];

